require('../../modules/es6.symbol');
require('../../modules/es6.object.to-string');
module.exports = require('../../modules/$.core').Symbol;


//////////////////
// WEBPACK FOOTER
// C:/wamp/www/node_modules/core-js/library/fn/symbol/index.js
// module id = 236
// module chunks = 0